import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseSelectComponent} from '@FormMakerReact/components/create-base-input-component';
import {PHONE_COUNTRY_CODE_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_COUNTRY_CODE_INPUT_TYPE = 'postermywall-country-code-input';
const COUNTRY_CODE_OPTIONS = '<option value="+1" disabled selected>🇺🇸 +1</option>';

export const POSTERMYWALL_COUNTRY_CODE_INPUT: AddComponentTypeOptions = createBaseSelectComponent({
  inputFieldType: POSTERMYWALL_COUNTRY_CODE_INPUT_TYPE,
  inputName: 'country-code',
  dataMarkerAttribute: 'data-is-pmw-form-country-code-select',
  displayName: 'Phone',
  style: PHONE_COUNTRY_CODE_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-country-code-select') !== null,
  defaultOptionsHtml: COUNTRY_CODE_OPTIONS,
});
